import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11 10v-5h-1m8 14v-5h-1","key":"svg-0"}],["path",{"d":"M15 5.5a.5 .5 0 0 1 .5 -.5h2a.5 .5 0 0 1 .5 .5v4a.5 .5 0 0 1 -.5 .5h-2a.5 .5 0 0 1 -.5 -.5l0 -4","key":"svg-1"}],["path",{"d":"M10 14.5a.5 .5 0 0 1 .5 -.5h2a.5 .5 0 0 1 .5 .5v4a.5 .5 0 0 1 -.5 .5h-2a.5 .5 0 0 1 -.5 -.5l0 -4","key":"svg-2"}],["path",{"d":"M6 10h.01m-.01 9h.01","key":"svg-3"}]]

const IconBinary = createReactComponent('outline', 'binary', 'Binary', __iconNode);

export default IconBinary;